import { EntityConfiguration, GroupConfig } from '../../modules/dto'

export interface ConfigState {
  configs: Record<string, EntityConfiguration> | null
  groupConfigs: Record<string, GroupConfig> | null
}

export const initialState: ConfigState = {
  configs: null,
  groupConfigs: null
}

export const configStoreKey = 'config'
